// Mirror of node_climato src/platform/kit/enums.ts — UpdateDataTable / UpdateStatus /
// UpdateDataType. `update_data.table_name` and `.status` are stored as compact
// smallint codes; the API returns codes and the UI maps them to labels here.
// NE JAMAIS renuméroter — keep in sync with the backend enum.

export const UPDATE_DATA_TABLE: Record<number, string> = {
  0: 'UNKNOWN',
  1: 'archive',
  2: 'archive_day_altimeter',
  3: 'archive_day_barometer',
  4: 'archive_day_consBatteryVoltage',
  5: 'archive_day_dewpoint',
  6: 'archive_day_ET',
  7: 'archive_day_extraHumid1',
  8: 'archive_day_extraHumid2',
  9: 'archive_day_extraTemp1',
  10: 'archive_day_extraTemp2',
  11: 'archive_day_extraTemp3',
  12: 'archive_day_hail',
  13: 'archive_day_hailRate',
  14: 'archive_day_heatindex',
  15: 'archive_day_heatingTemp',
  16: 'archive_day_heatingVoltage',
  17: 'archive_day_inHumidity',
  18: 'archive_day_inTemp',
  19: 'archive_day_inTempBatteryStatus',
  20: 'archive_day_leafTemp1',
  21: 'archive_day_leafTemp2',
  22: 'archive_day_leafWet1',
  23: 'archive_day_leafWet2',
  24: 'archive_day_outHumidity',
  25: 'archive_day_outTemp',
  26: 'archive_day_outTempBatteryStatus',
  27: 'archive_day_pressure',
  28: 'archive_day_radiation',
  29: 'archive_day_rain',
  30: 'archive_day_rainBatteryStatus',
  31: 'archive_day_rainRate',
  32: 'archive_day_referenceVoltage',
  33: 'archive_day_rxCheckPercent',
  34: 'archive_day_soilMoist1',
  35: 'archive_day_soilMoist2',
  36: 'archive_day_soilMoist3',
  37: 'archive_day_soilMoist4',
  38: 'archive_day_soilTemp1',
  39: 'archive_day_soilTemp2',
  40: 'archive_day_soilTemp3',
  41: 'archive_day_soilTemp4',
  42: 'archive_day_supplyVoltage',
  43: 'archive_day_txBatteryStatus',
  44: 'archive_day_UV',
  45: 'archive_day_wind',
  46: 'archive_day_windBatteryStatus',
  47: 'archive_day_windchill',
  48: 'archive_day_windDir',
  49: 'archive_day_windGust',
  50: 'archive_day_windGustDir',
  51: 'archive_day_windSpeed',
};

export function tableLabel(code: number): string {
  return UPDATE_DATA_TABLE[code] ?? `#${code}`;
}

// status: 0 WAITING, 1 DONE, 9 ERROR
export const STATUS_WAITING = 0;
export const STATUS_DONE = 1;
export const STATUS_ERROR = 9;

export const STATUS_OPTIONS: { value: number; label: string }[] = [
  { value: STATUS_WAITING, label: 'Waiting' },
  { value: STATUS_DONE, label: 'Done' },
  { value: STATUS_ERROR, label: 'Error' },
];

export function statusLabel(code: number): string {
  return STATUS_OPTIONS.find((s) => s.value === code)?.label ?? `#${code}`;
}

export function statusBadge(code: number): string {
  if (code === STATUS_DONE) return 'badge-green';
  if (code === STATUS_ERROR) return 'badge-red';
  return 'badge-amber'; // waiting
}

export function typeLabel(t: string): string {
  return t === 'U' ? 'Update' : t === 'D' ? 'Delete' : t;
}

// Local wall-clock render — NO new Date() (would double-shift a tz-less value).
// Input is "YYYY-MM-DDTHH:MM:SS"; show "YYYY-MM-DD HH:MM:SS".
export function fmtLocal(s: string): string {
  return s ? s.slice(0, 19).replace('T', ' ') : s;
}
